// Mock data for Gelibolu Hastane Taksi Durağı

export const companyInfo = {
  name: "Gelibolu Hastane Taksi Durağı",
  address: "Gazi Süleyman Paşa Mh. Mevlevihane Cd. No:39",
  city: "Gelibolu, Çanakkale",
  phone: "0286 566 6070",
  mobile: "0540 566 6070",
  coordinates: {
    lat: 40.4114,
    lng: 26.6708
  }
};

export const services = [
  {
    id: 1,
    title: "Şehir İçi Taksi",
    description: "Gelibolu içinde hızlı ve güvenli ulaşım hizmeti",
    icon: "MapPin"
  },
  {
    id: 2,
    title: "Hastane Transferi",
    description: "Hastane randevularınız için özel transfer hizmeti",
    icon: "Hospital"
  },
  {
    id: 3,
    title: "Havalimanı Transferi",
    description: "Çanakkale Havalimanı'na konforlu transfer",
    icon: "Plane"
  },
  {
    id: 4,
    title: "Şehirler Arası",
    description: "İstanbul, Çanakkale ve çevre illere güvenli yolculuk",
    icon: "MapPinned"
  },
  {
    id: 5,
    title: "7/24 Hizmet",
    description: "Gece gündüz kesintisiz taksi hizmeti",
    icon: "Clock"
  },
  {
    id: 6,
    title: "Özel Turlar",
    description: "Gelibolu ve çevre gezileri için özel araç kiralama",
    icon: "Compass"
  }
];

export const priceList = [
  {
    id: 1,
    route: "Gelibolu Şehir İçi",
    price: "Taksimetre",
    description: "Açılış: 15 TL"
  },
  {
    id: 2,
    route: "Çanakkale Merkez",
    price: "450 TL",
    description: "~45 dk"
  },
  {
    id: 3,
    route: "Çanakkale Havalimanı",
    price: "500 TL",
    description: "~50 dk"
  },
  {
    id: 4,
    route: "Eceabat",
    price: "300 TL",
    description: "~30 dk"
  },
  {
    id: 5,
    route: "Lapseki",
    price: "350 TL",
    description: "~35 dk"
  },
  {
    id: 6,
    route: "Tekirdağ",
    price: "800 TL",
    description: "~1.5 saat"
  }
];

export const fleet = [
  {
    id: 1,
    name: "Konfor Sedan",
    model: "Fiat Egea / Renault Megane",
    capacity: "4 Yolcu",
    luggage: "2 Bavul",
    image: "https://images.unsplash.com/photo-1628947733273-cdae71c9bfd3",
    features: ["Klima", "Temiz", "Konforlu"]
  },
  {
    id: 2,
    name: "Geniş Sedan",
    model: "Toyota Corolla / Volkswagen Passat",
    capacity: "4 Yolcu",
    luggage: "3 Bavul",
    image: "https://images.pexels.com/photos/5835061/pexels-photo-5835061.jpeg",
    features: ["Ekstra Bagaj", "Premium", "Konforlu"]
  },
  {
    id: 3,
    name: "Premium Araç",
    model: "Mercedes / BMW",
    capacity: "4 Yolcu",
    luggage: "3 Bavul",
    image: "https://images.unsplash.com/photo-1593950315186-76a92975b60c",
    features: ["Lüks", "VIP Hizmet", "Maksimum Konfor"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mehmet Yılmaz",
    comment: "Hastane randevularım için sürekli kullanıyorum. Çok güvenilir ve dakik bir hizmet.",
    rating: 5
  },
  {
    id: 2,
    name: "Ayşe Demir",
    comment: "Çanakkale'ye giderken tercih ediyorum. Şoförler çok kibar ve araçlar temiz.",
    rating: 5
  },
  {
    id: 3,
    name: "Ali Kaya",
    comment: "7/24 hizmet vermeleri çok iyi. Gece geç saatte bile hemen geliyorlar.",
    rating: 5
  }
];
